import { z } from 'zod';
/**
 * Admin roles (docs/01-PRD.md §4.1). Enforced server-side by AdminRoleGuard —
 * hiding navigation is a convenience, not a control (AC-ADMGL-01).
 */
export const AdminRole = z.enum(['super', 'moderator', 'support', 'finance']);
export const ADMIN_ROLES = AdminRole.options;
/** Report lifecycle for the moderation queue (FR-ADM-20). */
export const ReportState = z.enum(['open', 'claimed', 'actioned', 'dismissed', 'escalated']);
export const ModerationAction = z.enum([
    'dismiss',
    'hide_content',
    'delete_content',
    'warn_user',
    'suspend_user',
    'ban_user',
]);
/**
 * Every admin action requires a reason (AC-ADMGL-04). Modelled here so the
 * requirement cannot be forgotten at any call site.
 */
export const AdminActionInput = z.object({
    reason: z.string().min(10).max(1_000),
});
export const UpgradeRequestState = z.enum(['pending', 'approved', 'rejected', 'auto_closed']);
/** Append-only audit entry (FR-ADM-04, NFR-17). */
export const AuditEntry = z.object({
    id: z.string(),
    actorId: z.string(),
    /** A built-in key, or `custom:<name>` — forensics need the actual role, not just 'custom'. */
    actorRole: z.string(),
    action: z.string(),
    targetType: z.string(),
    targetId: z.string(),
    before: z.unknown().optional(),
    after: z.unknown().optional(),
    reason: z.string().optional(),
    ip: z.string(),
    at: z.coerce.date(),
});
//# sourceMappingURL=shared.js.map